import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { certifications } from '../../data/certifications';
const ease = [0.23, 1, 0.32, 1] as const;
export function CertificationsSection() {
  const [activeId, setActiveId] = useState(certifications[0].id);
  const active = certifications.find(c => c.id === activeId) ?? certifications[0];
  return <section aria-labelledby="certif-title" className="w-full bg-aloe-900 py-24 text-cream md:py-32" data-id="element-12" data-mp="27rgtztj55ng1">
      <div className="mx-auto max-w-7xl px-5 md:px-8" data-id="element-13" data-mp="22sx45i1ffrie">
        <h2 id="certif-title" className="max-w-3xl font-serif text-5xl leading-[1] md:text-7xl" data-id="element-14" data-mp="22sdns5rfdb6h">
          Les certifications <span className="italic text-leaf" data-id="element-15" data-mp="2hje6d3lvylgc">de nos produits.</span>
        </h2>

        <div className="mt-16 grid gap-10 lg:grid-cols-12 lg:gap-16" data-id="element-16" data-mp="2cj8lq7e19z7r">
          <div role="tablist" aria-label="Certifications" className="flex flex-col lg:col-span-5" data-id="element-17" data-mp="2qj9lfjikb0ln">
            {certifications.map(cert => {
            const selected = cert.id === activeId;
            return <button key={cert.id} type="button" role="tab" id={`tab-${cert.id}`} aria-selected={selected} aria-controls={`panel-${cert.id}`} onClick={() => setActiveId(cert.id)} className="group relative border-t border-cream/15 py-6 text-left last:border-b" data-id="element-18" data-mp="1uoovzl4dxukh">
                  {selected && <motion.span layoutId="certif-indicator" transition={{
                duration: 0.25,
                ease
              }} className="absolute left-0 top-[-1px] h-px w-full bg-leaf" data-id="element-19" data-mp="2hms1dq3lecrz" />}
                  <span className="block text-sm text-cream/50" data-id="element-20" data-mp="2rf7ikl72exbt">{cert.appliesTo}</span>
                  <span className={`mt-1 block font-serif text-3xl transition-colors duration-150 ease-out md:text-4xl ${selected ? 'text-cream' : 'text-cream/45 group-hover:text-cream/80'}`} data-id="element-21" data-mp="2wad4vl4dqe0f">
                    {cert.name}
                  </span>
                </button>;
          })}
          </div>

          <div className="lg:col-span-7" data-id="element-22" data-mp="2lfb3sm4jcv95">
            <AnimatePresence mode="wait" data-id="element-23" data-mp="2gm89ucvujjsf">
              <motion.div key={active.id} role="tabpanel" id={`panel-${active.id}`} aria-labelledby={`tab-${active.id}`} initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -6
            }} transition={{
              duration: 0.22,
              ease
            }} className="rounded-[2rem] bg-cream p-8 text-ink md:p-12" data-id="element-24" data-mp="2gl6zkamnn1br">
                <div className="flex h-24 items-center" data-id="element-25" data-mp="19z2zog9ghbvd">
                  {active.logo ? <img src={active.logo} alt={`Logo ${active.name}`} className="h-full w-auto max-w-[200px] object-contain" data-id="element-26" data-mp="150073vanwy4a" /> : <span className="flex h-24 w-24 items-center justify-center rounded-2xl bg-leaf font-sans text-4xl font-bold text-aloe-900" data-id="element-27" data-mp="3goo8lzg2tne4">
                      {active.mark}
                    </span>}
                </div>
                <p className="mt-8 text-xl leading-relaxed text-ink/80" data-id="element-28" data-mp="3buk0vdyzlbbz">{active.text}</p>
                <ul className="mt-8 flex flex-wrap gap-2" data-id="element-29" data-mp="2xvklkwxd68sh">
                  {active.principles.map(p => <li key={p} className="rounded-full bg-sand px-4 py-2 text-sm font-medium text-aloe-900" data-id="element-30" data-mp="31ygw00cr2ylc">
                      {p}
                    </li>)}
                </ul>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </section>;
}